import { AccountInfo } from '@azure/msal-browser';
import { IAccountInfo } from '../../domain/models/auth-session.model';
import { IVerifyResponseDto } from '../dtos/verify-response.dto';
import { ILogoutResponseDto } from '../dtos/logout-response.dto';
import { ILoginResponse } from '../../domain/interfaces/login.interface';
import { ILogoutResponse } from '../../domain/interfaces/logout.interface';
import { RESPONSE_MESSAGE } from 'src/app/shared/constants/response.constants';
import { HttpStatusCode } from '@angular/common/http';

export class AuthMappers {
  static toAccountInfoModel(msalAccount: AccountInfo): IAccountInfo {
    return {
      localAccountId: msalAccount.localAccountId,
      username: msalAccount.username,
      name: msalAccount.name,
      homeAccountId: msalAccount.homeAccountId,
      environment: msalAccount.environment,
      tenantId: msalAccount.tenantId,
    };
  }

  static toVerifySessionResponse(dto: IVerifyResponseDto): ILoginResponse {
    return {
      success: Number(dto.code) === HttpStatusCode.Ok,
      message: dto.message,
      data: {
        token: dto.data.token,
      },
    };
  }

  static toLogoutResponse(dto: ILogoutResponseDto): ILogoutResponse {
    return {
      success: dto.message === RESPONSE_MESSAGE.OK,
      message: dto.message,
    };
  }
}
